import type { TasksResponse } from "../../contracts/index";
import type { TasksSearch } from "../search";

export interface FilterChipValue {
  label: string;
  value: string;
  clear: Partial<TasksSearch>;
}

export function filterChips(search: TasksSearch, data: TasksResponse | undefined): FilterChipValue[] {
  const typeLabels = new Map(data?.facets.types.map((t) => [t.key, t.label]));
  return [
    ...(search.type ?? "")
      .split(",")
      .filter(Boolean)
      .map((t) => ({
        label: "Type",
        value: typeLabels.get(t) ?? t,
        clear: {
          type:
            (search.type ?? "")
              .split(",")
              .filter((x) => x !== t && x !== "")
              .join(",") || undefined,
        },
      })),
    ...(search.person
      ? [
          {
            label: "Person",
            value: data?.facets.people.find((p) => p.key === search.person)?.label ?? search.person,
            clear: { person: undefined },
          },
        ]
      : []),
    ...(search.platform ? [{ label: "Platform", value: search.platform, clear: { platform: undefined } }] : []),
    ...(search.age
      ? [
          {
            label: "Age",
            value: data?.facets.ages.find((a) => a.key === search.age)?.label ?? search.age,
            clear: { age: undefined },
          },
        ]
      : []),
    ...(search.q ? [{ label: "Text", value: search.q, clear: { q: undefined } }] : []),
  ];
}

export function summaryText(
  data: TasksResponse | undefined,
  view: "open" | "done",
  filtered: boolean,
  scope: TasksSearch["scope"],
): string | null {
  if (!data) return null;
  if (view === "done")
    return `${String(data.counts.done)} done in the last 30 days · ${String(data.counts.done_by_person)} resolved by a person · ${String(data.counts.done_automatically)} closed automatically`;
  if (filtered) return `Showing ${String(data.counts.matching)} of ${String(data.counts.in_view)}`;
  if (scope === "all") return `All ${String(data.counts.open)} open tasks, highest priority first`;
  return `${String(data.counts.actionable)} you can act on · ${String(data.counts.open - data.counts.actionable)} more under All tasks`;
}
